import copy from 'copy-to-clipboard'

$(function() {
    const lang = $('html').attr('lang')
    $('blockquote').each(function() {
        let link =$('<a />')
            .attr({'href': '#'})
            .css({marginTop: 15, marginBottom: 15, display: 'block'})
            .text(lang === 'ru' ? 'Скопировать в буфер обмена' : 'Copy to clipboard')
            .click(() => {
                copy(
                    $(this).html()
                        .replace(/<br\s*[\/]?>/gi, "\n") // break line
                        .replace(/<[^>]*>?/gm, '') // remove tags
                );
                link.text(lang === 'ru' ? 'Скопировано!' : 'Text is copied!').css({color: '#12ad00'})
                return false
            });
        link.insertAfter($(this))
    })
})

